import { render, staticRenderFns } from "./SidenavMenu.vue?vue&type=template&id=5665ae4a"
import script from "./SidenavMenu.vue?vue&type=script&lang=js"
export * from "./SidenavMenu.vue?vue&type=script&lang=js"
import style0 from "./SidenavMenu.vue?vue&type=style&index=0&id=5665ae4a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports